import colors from './colors';
import dimensions from './dimensions';
import typography from './typography';

export { colors, dimensions, typography };



// WEBPACK FOOTER //
// src/dialpad/components/common/styles/index.js